import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  private _deviceData: any = null;
  private _isInitialized: boolean = false;
  private _initPromise: Promise<any> | null = null;

  constructor(private http: HttpClient) {}

  public get deviceData(): any {
    return this._deviceData;
  }

  public get isInitialized(): boolean {
    return this._isInitialized;
  }

  /**
   * Executa a rota GET /api/v2/device/init como primeira ação da aplicação
   * através de APP_INITIALIZER no AppModule antes de qualquer outra requisição.
   */
  public initDevice(): Promise<any> {
    if (this._initPromise) {
      return this._initPromise;
    }

    const apiBase = (
      environment.apiUrl ||
      environment.baseUrl ||
      sessionStorage.getItem('apiURL') ||
      localStorage.getItem('apiURL') ||
      'https://api.tecnologiaasap.com.br'
    ).replace(/\/+$/, '');

    const cleanUrl = `${apiBase}/api/v2/device/init`.replace(/([^:]\/)\/+/g, '$1');

    console.log('[DeviceService] Carregando /api/v2/device/init antes de qualquer outra requisição:', cleanUrl);

    this._initPromise = this.http.get(cleanUrl, {
      headers: {
        'X-Device-Context': 'asap_authorized_access'
      }
    })
      .toPromise()
      .then((response: any) => {
        console.log('[DeviceService] Dispositivo inicializado com sucesso:', response);
        this._deviceData = response;
        this._isInitialized = true;
        return response;
      })
      .catch((error: any) => {
        console.error('[DeviceService] Erro ao inicializar dispositivo:', error);
        // Permite retry no futuro caso tenha falhado temporariamente
        this._initPromise = null;
        // Retorna null para permitir que o Angular continue o bootstrap
        return null;
      });

    return this._initPromise;
  }
}
